module.exports = __webpack_public_path__ + "img/lg_ring_skip_0_null_1.8fcf2fd4.png";